interface IExtraField {
    type: string;
    name: string;
    defaultValue?: string;
    data?: any[];
}

interface IEmailMap {
    [key: string]:
        | {
              type: 'klaviyo';
              list_id: string;
              source: string;
              consent_form_id: string;
              popupBtnLink: string;
              SmartDevices?: string;
          }
        | {
              type: 'mailchimp';
              action: string;
              extraFields?: IExtraField[];
              popupBtnLink: string;
          } | any;
}

export const emailMap: IEmailMap = {
    us: {
        type: 'klaviyo',
        list_id: 'Tyc3ux',
        source: 'EcoFlow Glacier Teaser from',
        consent_form_id: 'W2QtQS',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowwave?utm_source=Web&utm_medium=brandwebsite&utm_campaign=smartdevices',
    },
    ca: {
        type: 'klaviyo',
        list_id: 'VR8XxE',
        source: 'EcoFlow Glacier Teaser from',
        consent_form_id: 'SuKdsH',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowwave?utm_source=Web&utm_medium=brandwebsite&utm_campaign=smartdevices',
    },
    eu: {
        type: 'klaviyo',
        list_id: 'VcNvHa',
        source: 'EcoFlow Glacier Teaser from',
        consent_form_id: 'VW84Lg',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowwave?utm_source=Web&utm_medium=brandwebsite&utm_campaign=smartdevices',
    },
    uk: {
        type: 'klaviyo',
        list_id: 'UT8ekS',
        source: 'EcoFlow Glacier Teaser from',
        consent_form_id: 'VisejD',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowwave?utm_source=Web&utm_medium=brandwebsite&utm_campaign=smartdevices',
    },
    de: {
        type: 'klaviyo',
        list_id: 'XpuT4D',
        source: 'EcoFlow Glacier Teaser from',
        consent_form_id: 'R4rUvy',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowclubdeutsch?utm_source=Web&utm_medium=officialwebsite&utm_campaign=smartdevices',
    },
    fr: {
        type: 'klaviyo',
        list_id: 'S5ieJs',
        source: 'EcoFlow Glacier Teaser from',
        consent_form_id: 'W2NMgX',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowfrancophone?utm_source=Web&utm_medium=officialwebsite&utm_campaign=smartdevices',
    },
    it: {
        type: 'klaviyo',
        list_id: 'T3j4K2',
        source: 'EcoFlow Glacier Teaser from',
        consent_form_id: 'T6hiWN',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowwave?utm_source=Web&utm_medium=brandwebsite&utm_campaign=smartdevices',
    },
    es: {
        type: 'klaviyo',
        list_id: 'WVnR2R',
        source: 'EcoFlow Glacier Teaser from',
        consent_form_id: 'XNDEGz',
        popupBtnLink: 'https://www.facebook.com/groups/ecoflowwave?utm_source=Web&utm_medium=brandwebsite&utm_campaign=smartdevices',
    },
    jp: {
        type: 'mailchimp',
        action: 'https://ecoflow.us8.list-manage.com/subscribe/post?u=d002bf04842356c4c1c5221cf&amp;id=440b6cbd62&amp;f_id=00b372e1f0',
        popupBtnLink: 'https://lin.ee/g7W0VbD',
    },
    au: {
        type: 'klaviyo',
        list_id: 'TaE2Di',
        source: 'EcoFlow Glacier Teaser from',
        consent_form_id: 'RyF9Uj',
        popupBtnLink: 'https://www.facebook.com/groups/efaustralia/',
    },
    za: {
        type: 'emarsys',
        popupBtnLink: 'https://www.facebook.com/groups/efsouthafrica',
    },
};
